import React, { useEffect, useState } from "react";
import "./style.scss";
import AssetDefaultIcon from "../../../../assets/AssetIcon.svg";
import { AssetType } from "static/types";
import { CURRENCY_FLAGS } from "static/currencies";
import { sircapApi } from "shared/api/sircap";

type PropsType = {
  className?: string;
  asset:
    | {
        type: number;
        symbol: string;
        currency?: { code: string };
        image?: string;
      }
    | any;
  swapCurrency?: boolean;
  defaultIcon?: string;
  onGetImageUrl?: (url: string) => void;
  onGetBrokenImage?: (message: string) => void;
};

const AssetIcon: React.FC<PropsType> = React.memo(
  ({
    asset,
    className = "",
    defaultIcon = "",
    swapCurrency = false,
    onGetImageUrl,
    onGetBrokenImage,
  }) => {
    const [img, setImg] = useState(defaultIcon);

    useEffect(() => {
      if (
        [
          AssetType.ETF,
          AssetType.Stock,
          AssetType.Fond,
          AssetType.Crypto,
          AssetType.Option,
        ].includes(asset.type)
      ) {
        if (asset?.image) {
          setImg(asset?.image);
        } else {
          setImg(asset.symbol);
        }
      } else if (asset.type === AssetType.Currency) {
        setImg(CURRENCY_FLAGS[asset.symbol]);
      } else if ([AssetType.Bond, AssetType.EuroBond].includes(asset.type)) {
        if (asset?.image) {
          setImg(asset.image);
        } else {
          setImg(asset.symbol);
        }
      } else if ([AssetType.StructuredProduct].includes(asset.type)) {
        if (asset?.image) {
          setImg(asset.image);
        } else {
          setImg(asset.symbol);
        }
      } else {
        setImg("");
      }
    }, [asset]);

    useEffect(() => {
      if (img && onGetImageUrl) {
        onGetImageUrl(img);
      }
    }, [img]);

    if (asset.type === AssetType.Currency) {
      return (
        <div className="currency-exchange-rate-icons">
          <div className="exchange-rate-first">
            <img
              src={
                swapCurrency
                  ? CURRENCY_FLAGS[asset?.currency?.code]
                  : CURRENCY_FLAGS[asset.symbol]
              }
              alt="icon"
              loading="lazy"
            />
          </div>
          <div className="exchange-rate-second">
            {/* @ts-ignore */}
            <img
              src={
                swapCurrency
                  ? CURRENCY_FLAGS[asset.symbol]
                  : CURRENCY_FLAGS[asset?.currency?.code]
              }
              alt="icon"
              loading="lazy"
            />
          </div>
        </div>
      );
    }

    if (!img) {
      return (
        <img
          className={className}
          crossOrigin="anonymous"
          src={defaultIcon || AssetDefaultIcon}
          alt="Icon"
        />
      );
    }

    const onError = async (e: any) => {
      // @ts-ignore
      e.target.src = defaultIcon || AssetDefaultIcon;
      const resp = await sircapApi.market.assetIcon(asset.type, asset.symbol)();
      setImg(resp.data);
      onGetBrokenImage?.("broken");
    };

    return (
      <div className={className ? "" : "asset-info-icon-wrapper"}>
        <img
          className={className}
          style={{
            // filter: "brightness(0.9)",
            maxWidth: "40px",
            height: "40px",
            borderRadius: "20px",
            ...([AssetType.Bond, AssetType.EuroBond].includes(asset.type)
              ? { objectFit: img.includes("flag") ? "cover" : "contain" } // cover
              : { objectFit: "contain" }),
          }}
          src={img}
          alt="Icon"
          onError={onError}
          loading="lazy"
        />
      </div>
    );
  },
  (prev, next) => {
    if (prev.asset.symbol === next.asset.symbol) return true;
    else return false;
  },
);

export default AssetIcon;
